<template>
  <div class="col-12 col-md-6 col-xl-4 p-4">
    <div class="card bg-dark text-white">
      
      <div class="row pl-2 pt-1 d-block d-sm-none">
        <div class="col-12">
          <h5 class="card-text" v-html="provider.title"></h5>
        </div>
      </div>
      <div class="row no-gutters p-1">
        <div class="col-5 align-self-center">
          <img :src="provider.img" class="card-img" :alt="provider.img" />
        </div>
        <div class="col-7">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block" v-html="provider.title"></h5>
            <p class="card-text">{{provider.text}}</p>
            <button class="btn btn-primary d-none" @click="$emit('startAddProvider', provider.id);">
              {{provider.btnText}}
              <i :class="provider.btnIcon"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-12">
          <button
            class="btn btn-primary btn-block"
            @click="$emit('startAddProvider', provider.id);"
          >
            {{provider.btnText}}
            <i :class="provider.btnIcon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProviderFeed",
  props: {
    provider: Object
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
